<template>
  <div id="bidfile" class="zl-form-group file-contaniner">
    <div class="zl-form-group-header">
      <div class="zl-form-group-title">
        <i class="title-decorate iconfont icon-decorate" />
        竞价文件
      </div>
    </div>
    <div class="zl-form-group-form">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="项目编号" prop="biddingNo" label-width="70px">
            <el-input v-if="!isDisplay" v-model="form.biddingNo" :disabled="isEdit" />
            <span v-else class="mybidding-display"> {{ form.biddingNo }} </span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="项目名称" prop="biddingName" label-width="70px">
            <el-input v-if="!isDisplay" v-model="form.biddingName" />
            <span v-else class="mybidding-display"> {{ form.biddingName }} </span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="计划签约日期" prop="planSignDate" label-width="100px">
            <el-date-picker
              v-if="!isDisplay"
              v-model="form.planSignDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            />
            <span v-else class="mybidding-display"> {{ form.planSignDate }} </span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="项目预算" prop="projectBudget" label-width="70px">
            <el-input v-if="!isDisplay" v-model="form.projectBudget" />
            <span v-else class="mybidding-display"> {{ form.projectBudget }} </span>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="file-detail">
        <p>竞价明细</p>
        <div v-if="!isDisplay" class="right" @click="addLine">
          <i class="iconfont icon-xinzeng" />添加一行
        </div>
      </div>
      <el-row style="padding-bottom:18px">
        <el-col>
          <el-table :data="form.goodsList" stripe style="width: 100%" :header-cell-style="{ background: '#e9f3fe', color: '#666666', fontSize: '12px', fontWeight: 'bold' }" class="table">
            <el-table-column type="index" width="50" label="#" />
            <el-table-column prop="goodsType" label="类型" width="150">
              <template slot="header">
                <span class="requireds">类型</span>
              </template>
              <template v-slot="{ row }" label-class-name="requireds">
                <el-select v-if="!isDisplay" v-model="row.goodsType" placeholder="请选择">
                  <el-option
                    v-for="item in goodsTypeOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <span v-else> {{ +row.goodsType===1 ?'物资':'工艺' }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="number" label="编码" width="200">
              <template slot="header">
                <span class="requireds">编码</span>
              </template>
              <template v-slot="{ row, $index }">
                <el-input
                  v-if="+row.goodsType===1 && !isDisplay"
                  :value="row.number"
                  placeholder=""
                >
                  <i v-if="!isDisplay" slot="suffix" class="common-hand el-input__icon iconfont  icon-sousuo" @click="chooseNumber($index)" />
                </el-input>
                <span v-else-if="isDisplay"> {{ row.number }} </span>
                <el-input
                  v-else
                  v-model="row.number"
                  placeholder=""
                />
              </template>
            </el-table-column>
            <el-table-column prop="name" label="名称" width="200">
              <template slot="header">
                <span class="requireds">名称</span>
              </template>
              <template v-slot="{ row }">
                <el-input
                  v-if="!isDisplay"
                  v-model="row.name"
                  placeholder=""
                />
                <span v-else> {{ row.name }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="model" label="型号" width="200">
              <template slot="header">
                <span class="requireds">型号</span>
              </template>
              <template v-slot="{ row }">
                <el-input
                  v-if="!isDisplay"
                  v-model="row.model"
                  placeholder=""
                />
                <span v-else> {{ row.model }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="category" label="所属类目" width="150">
              <template v-slot="{ row }">
                <el-input
                  v-if="!isDisplay"
                  v-model="row.category"
                  placeholder=""
                />
                <span v-else> {{ row.category }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="technologyName" label="工艺" width="150">
              <template v-slot="{ row }">
                <el-input
                  v-if="!isDisplay"
                  v-model="row.technologyName"
                  placeholder=""
                  :disabled="+row.goodsType ===1 "
                />
                <span v-else> {{ row.technologyName }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="unit" label="单位" width="150">
              <template slot="header">
                <span class="requireds">单位</span>
              </template>
              <template v-slot="{ row }">
                <el-input
                  v-if="!isDisplay"
                  v-model="row.unit"
                  placeholder=""
                />
                <span v-else> {{ row.unit }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="currencyNo" label="币种" width="150">
              <template slot="header">
                <span class="requireds">币种</span>
              </template>
              <template v-slot="{ row }">
                <el-select
                  v-if="!isDisplay"
                  v-model="row.currencyNo"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请搜索"
                  :remote-method="remoteMethod"
                  clearable
                  :loading="selectLoding"
                  @change="manageSelect"
                >
                  <el-option
                    v-for="item in rmbOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <span v-else> {{ row.currencyNo }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="qty" label="数量" width="150">
              <template slot="header">
                <span class="requireds">数量</span>
              </template>
              <template v-slot="{ row, $index }">
                <el-input
                  v-if="!isDisplay"
                  v-model="row.qty"
                  placeholder=""
                  @change="amountChange(row, 'qty', $index)"
                />
                <span v-else> {{ row.qty }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="fixedPrice" label="限价" width="150">
              <template v-slot="{ row, $index }">
                <el-input
                  v-if="!isDisplay"
                  v-model="row.fixedPrice"
                  placeholder=""
                  @change="amountChange(row, 'fixedPrice', $index)"
                />
                <span v-else> {{ row.isDisplay }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="purchaseStandard" label="采购标准" width="150">
              <template v-slot="{ row }">
                <el-input
                  v-if="!isDisplay"
                  v-model="row.purchaseStandard"
                  placeholder=""
                />
                <span v-else> {{ row.purchaseStandard }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="expectedDeliveryDate" label="期望交货日期" width="200">
              <template v-slot="{ row }">
                <el-date-picker
                  v-if="!isDisplay"
                  v-model="row.expectedDeliveryDate"
                  type="date"
                  placeholder="选择日期时间"
                  value-format="yyyy-MM-dd"
                />
                <span v-else> {{ row.expectedDeliveryDate }} </span>
              </template>
            </el-table-column>
            <el-table-column prop="goodsFileList" label="附件" width="150">
              <template v-slot="{ row }">
                <el-button type="text" @click="uploadFile(row)">{{ (row.goodsFileList && row.goodsFileList.length>0)?`${row.goodsFileList.length}个附件`:(isDisplay? '0个附件' : '点击添加') }}</el-button>
              </template>
            </el-table-column>
            <el-table-column v-if="!isDisplay" label="操作" width="100" fixed="right" align="center">
              <template v-slot="{ $index }">
                <el-button type="text" size="mini" @click="fileDel($index)"> 删除 </el-button>
              </template>
            </el-table-column>
            <template slot="empty">
              <slot name="empty">
                <div class="empty">
                  <svg-icon class-name="empty__img" icon-class="default" />
                  <p class="empty__desc">{{ $t('common.empty') }}</p>
                </div>
              </slot>
            </template>
          </el-table>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      title="选择编码"
      :visible.sync="dialogVisible"
      width="70%"
      @close="handleClose"
    >
      <el-row style="margin-bottom: 10px">
        <el-col :span="8">
          <el-input v-model="numberKeyWord" :placeholder="$t('bidmanagementpur.mybidding.bindFileSearchPlaceholder')"> <i slot="suffix" class="common-hand el-input__icon iconfont  icon-sousuo" @click="searchNumber" /> </el-input>
        </el-col>
      </el-row>
      <div>
        <el-table v-loading="searchLoading" max-height="600px" :default-sort="{prop: 'number', order: 'descending'}" stripe :data="goodShowList" style="width: 100%" :header-cell-style="{ background: '#e9f3fe', color: '#666666', fontSize: '12px', fontWeight: 'bold' }" class="table" @sort-change="sortChange" @selection-change="handleSelectionChange">
          <el-table-column
            type="selection"
            width="55"
          />
          <el-table-column type="index" width="50" label="#" />
          <el-table-column prop="number" label="编码" sortable="number" />
          <el-table-column prop="name" label="名称" />
          <el-table-column prop="model" label="型号" />
          <el-table-column prop="unit" label="单位" />
        </el-table>
        <el-pagination
          class="rigth"
          :page-sizes="[20, 30, 50, 100]"
          :page-size="querInfo.pagesize"
          :total="total"
          layout="->,total, prev, pager, next, sizes"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addGood">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="添加附件"
      :visible.sync="fileVisible"
      width="550px"
      append-to-body
    >
      <div class="round-upload">
        <UploadSelect
          v-model="batchFile.goodsFileList"
          :url="url"
          :limit="0"
          :base-u-r-l="baseURL"
          :get-data="() => ({ fileType: 'bidding' })"
          name="files"
          :disabled="isDisplay"
          :on-success="onSuccess"
          :is-lnline="false"
          :click-file="clickFile"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { clickFile } from '../config/fn'
import http from '@/plugin/axios'
import UploadSelect from './upload-select.vue'
export default {
  components: {
    UploadSelect
  },
  props: {
    form: {
      type: Object,
      default: () => []
    },
    templateDataSource: {
      type: Object,
      default: () => []
    },
    goodsTypeOption: {
      type: Array,
      default: () => []
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isDisplay: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      clickFile: clickFile,
      dialogVisible: false,
      fileVisible: false,
      querInfo: {
        pagenum: 1,
        pagesize: 20
      },
      multipleSelection: [],
      goodShowList: [],
      curIndex: '', // 当前选中值
      numberKeyWord: '',
      total: 0,
      selectLoding: false,
      rmbOption: [],
      batchFile: [], // 当前选择附件
      baseURL: process.env.VUE_APP_BASE_API,
      url: '/srmFile/uploadFiles',
      searchLoading: false,
      currentSort: { field: 'number', order: 'desc' }
    }
  },
  computed: {
    num() {
      return (this.form.goodList && this.form.goodList.length) || 0
    },
    isSure() {
      return this.multipleSelection.length === 1
    }
  },
  created() {
    if (!this.isDisplay) {
      this.search()
      this.cnBGet()
    }
  },
  methods: {
    handleClose() {
      this.searchLoading = false
    },
    searchNumber() {
      this.search()
    },
    onSuccess(_this, data) {
      const file = data.data || []
      _this.fileList.push(...file)
      _this.$emit('input', _this.fileList)
    },
    uploadFile(row) {
      this.batchFile = row
      this.fileVisible = true
    },
    addLine() {
      this.$emit('addLine')
    },
    fileDel(index) {
      this.$emit('fileDel', index)
    },
    amountChange(row, key, index) {
      const amount = row[key]
      if (isNaN(amount)) {
        row.key = 0
        let tips = ''
        switch (key) {
          case 'qty' :
            tips = `竞价明细第${index + 1}行数量必须为自然数`
            break
          case 'fixedPrice' :
            tips = `竞价明细第${index + 1}行限价必须为大于零的数字`
            break
        }
        return this.$message({
          message: tips,
          type: 'warning'
        })
      }
    },
    chooseNumber(index) {
      this.curIndex = index
      this.search()
      this.dialogVisible = true
    },
    // 传递赋值
    addGood() {
      if (!this.isSure) {
        this.$message({
          message: '请选择一行物料',
          type: 'warning'
        })
        return
      }
      if (this.form.goodsList.length > 0) {
        const goodsList = this.form.goodsList || []
        for (let i = 0; i < this.multipleSelection.length; i++) {
          const index = goodsList.findIndex((ele) => {
            return ele.number === this.multipleSelection[i].number
          })
          if (index > -1) {
            return this.$message({
              message: `编码和第${index + 1}行重复`,
              type: 'warning'
            })
          }
        }
      }
      this.$emit('delGoodFile', this.multipleSelection, this.curIndex)
      this.dialogVisible = false
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页器
    handleSizeChange(val) {
      this.querInfo.pagesize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.querInfo.pagenum = val
      this.search()
    },
    async search() {
      try {
        this.searchLoading = true
        const params = { keyword: this.numberKeyWord }
        if (Object.keys(this.currentSort).length > 0) {
          params.field = this.currentSort.field
          params.order = this.currentSort.order
        }
        const info = await http({
          url: '/srmBiddingHead/getGoodsListForBidding',
          baseURL: process.env.VUE_APP_PURCHASE_API,
          data: {
            condition: {
              ...params,
              ...this.sort
            },
            current: this.querInfo.pagenum,
            size: this.querInfo.pagesize
          }
        })
        this.goodShowList = info.records
        this.total = info.total
      } catch (error) {
        console.log(error)
      } finally {
        this.searchLoading = false
      }
    },
    sortChange(column) {
      this.currentSort = { field: column.prop, order: column.order === 'descending' ? 'desc' : 'asc' }
      this.search()
    },
    remoteMethod(query) {
      this.cnBGet(query)
    },
    manageSelect(item) {
      console.log(item)
    },
    async cnBGet(query) {
      this.selectLoding = true
      const params = { keyword: query }
      const info = await http({
        url: '/srmCurrencyExchange/getSrmCurrencyExchangePage',
        baseURL: process.env.VUE_APP_PURCHASE_API,
        data: {
          condition: {
            ...params
          },
          current: 1,
          size: 10
        }
      }) || {}
      setTimeout(() => {
        this.selectLoding = false
      }, 300)
      const rmbOption = info.records || []
      this.rmbOption = rmbOption.map((ele) => {
        return { label: `${ele.currencyNo}-${ele.currencyName}`, value: ele.currencyNo }
      })
    }
  }

}
</script>
<style lang="scss" scoped>
@import './common.scss';
.file-detail{
  display: flex;
  justify-content: space-between;
  .right{
    display: flex;
    align-items: center;
    cursor: pointer;
  }
}
.file-contaniner{
  /deep/ {
    .el-table th > .cell {
      padding-left: 14px;
    }
  }
}
</style>
